import { render, staticRenderFns } from "./PurchaseNoticeDetail.vue?vue&type=template&id=dc463eea&scoped=true"
import script from "./PurchaseNoticeDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseNoticeDetail.vue?vue&type=style&index=0&id=dc463eea&prod&lang=scss"
import style1 from "./PurchaseNoticeDetail.vue?vue&type=style&index=1&id=dc463eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc463eea",
  null
  
)

export default component.exports